import { ref, watch } from "vue";

// Module-scoped reactive ref so Dashboard, Schedule, and History all read/write
// the same value. Persisted to localStorage so the choice survives reload.

var KEY = "bed.selectedSide";

function load() {
	try {
		var raw = localStorage.getItem(KEY);
		if (raw === "left" || raw === "right") { return raw; }
	} catch (e) { /* ignore */ }
	return "left";
}

var selectedSide = ref(load());

watch(selectedSide, (v) => {
	if (v === "left" || v === "right") {
		try { localStorage.setItem(KEY, v); } catch (e) { /* ignore */ }
	}
});

export function useSelectedSide() {
	return selectedSide;
}
